import {configureStore} from '@reduxjs/toolkit'

import account from '~/reducers/account'
import deviceInfo from '~/reducers/deviceInfo'
import feedBack from '~/reducers/feedBack'
import global from '~/reducers/global'
import modelPlaza from '~/reducers/modelPlaza'
import share from '~/reducers/share'
import youSuTong from '~/reducers/youSuTong'

export const createStore = (state?) =>
  configureStore({
    reducer: {
      global,
      deviceInfo,
      account,
      feedBack,
      share,
      modelPlaza,
      youSuTong,
    },
    preloadedState: state,
  })
// @ts-ignore
export type StoreType = ReturnType<typeof createStore>

export type RootState = ReturnType<StoreType['getState']>
export type AppDispatch = StoreType['dispatch']
